import { FC, ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router';
import { connect, ConnectedProps, useDispatch } from 'react-redux';
import { TenantActions } from 'Store/Tenant/Tenant.actions';
import { ObraActions } from 'Store/Obra/Obra.actions';
import { NomenclaturaActions } from 'Store/Nomenclatura/Nomenclatura.actions';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { HelperActions } from 'Store/Helper/Helper.actions';
import { ListagemArquivosActions } from 'Store/ListagemArquivos/ListagemArquivos.actions';
import { RELOAD_DISCIPLINAS_KEY } from 'Pages/Disciplinas';
import { RELOAD_LISTAGEM_ARQUIVOS_KEY } from 'Pages/ListagemArquivos';
import PreferencesModal from 'Components/UI/PreferencesModal';
import FollowInfoCard from 'Components/UI/FollowInfoCard';
import LeftBar from './LeftBar';
import AdmLeftBar from './AdmLeftBar';
import TopBar from './TopBar';
import { ShellHostStyled } from './styles';

export interface IShellHost {
  children?: ReactNode;
  hiddenShell: boolean;
}

const ShellHost: FC<Props> = ({
  children,
  hiddenShell,
  isCollapsed,
  showInfoCard,
  showPreferencesModal
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isAdmRoute = location.pathname.startsWith('/adm');

  const toggleCollapse = () => {
    dispatch(ObraActions.toggleCollapse(!isCollapsed));
  };

  const hidePreferencesModal = () => {
    dispatch(HelperActions.toggleShowPreferencesModal(false));
  };

  const hideShowInfoCard = () => {
    dispatch(ListagemArquivosActions.toggleShowInfoCard(false));
  };

  useEffect(() => {
    if (window.innerWidth <= 1366) {
      dispatch(ObraActions.toggleCollapse(true));
    }
  }, []);

  useEffect(() => {
    dispatch(TenantActions.getTenantRoles());
    dispatch(TenantActions.getTenantUsers());
    dispatch(TenantActions.listUserTenants());
    dispatch(ObraActions.getDisciplines());
    dispatch(NomenclaturaActions.getNomenclature());

    if (window) {
      (window as any)[RELOAD_DISCIPLINAS_KEY] = true;
      (window as any)[RELOAD_LISTAGEM_ARQUIVOS_KEY] = true;
    }
  }, [dispatch]);

  return (
    <ShellHostStyled hidden={hiddenShell} isCollapsed={`${isCollapsed}`}>
      <div className="content">
        <TopBar onCollapseClick={toggleCollapse} isCollapsed={isCollapsed} />
        {isAdmRoute ? (
          <AdmLeftBar isCollapsed={isCollapsed} />
        ) : (
          <LeftBar isCollapsed={isCollapsed} />
        )}
        <main className="main">
          {children}
        </main>
      </div>

      {showPreferencesModal && (
        <PreferencesModal
          visible={showPreferencesModal}
          onCancel={hidePreferencesModal}
        />
      )}

      {showInfoCard && <FollowInfoCard onClose={hideShowInfoCard} />}
    </ShellHostStyled>
  );
};

const mapState = (state: IGlobalReducerState) => ({
  isCollapsed: state.obra.isCollapsed,
  showInfoCard: state.listagemArquivos.showInfoCard,
  showPreferencesModal: state.helper.showPreferencesModal,
});

const connector = connect(mapState);

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux & IShellHost;

export default connector(ShellHost);
